import SlDialog from '@shoelace-style/shoelace/dist/react/dialog/index.js';
import '@shoelace-style/shoelace/dist/components/dialog/dialog.js';
import SlButton from '@shoelace-style/shoelace/dist/react/button/index.js';
import '@shoelace-style/shoelace/dist/components/button/button.js';
import '@shoelace-style/shoelace/dist/themes/light.css';
import SlCheckbox from '@shoelace-style/shoelace/dist/react/checkbox/index.js';
import React, { useState } from 'react';
import { useApi } from './useApi';

import './DislikeModal.css';

export default function DislikeModal(props) {
  const { authPost } = useApi();
  const [selected, setSelected] = useState([]);
  const [comments, setComments] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [checkboxError, setCheckboxError] = useState("");
  const [commentsError, setCommentsError] = useState("");
  
  // Use userId from props (from auth context)
  const userId = props.userId;
  const apiBaseUrl = process.env.REACT_APP_API_URL;
  const feedbackApi = `${apiBaseUrl}/userfeedback`;
  
  const options = [
    "AI Summary is incorrect",
    "Title does not match the original source",
    "Source URL is not working or incorrect",
    "Showing Error Message",
    "Detail Page not opening"
  ];

  async function handleSubmit() {
    // Validation: require at least one checkbox AND comments
    let hasError = false;
    
    if (selected.length === 0) {
      setCheckboxError("Please select at least one option.");
      hasError = true;
    }
    
    if (comments.trim() === "") {
      setCommentsError("Please provide additional information.");
      hasError = true;
    }
    
    if (hasError) return;
    
    if (!props.articleData) {
      console.error("No article data available");
      return;
    }
    
    const payload = {
      userId: userId,
      articleId: props.articleData.id,
      feedbackType: "dislike",
      feedbackList: selected,
      feedbackComment: comments
    };
    
    console.log("Submitting dislike feedback:", payload);
    setIsSubmitting(true);
    
    try {
      const response = await authPost(feedbackApi, payload);
      
      if (response.ok) {
        console.log("Dislike feedback submitted successfully");
        props.onSubmit({ selected, comments });
      } else {
        console.error("Failed to submit dislike feedback:", response.status);
      }
    } catch (error) {
      console.error("Error submitting dislike feedback:", error);
    } finally {
      setIsSubmitting(false);
      setSelected([]);
      setComments("");
    }
  }

  function handleCheckboxChange(value, checked) {
    console.log(value);
    setCheckboxError(""); // Clear error when user selects
    if (checked) {
      setSelected(prev => [...prev, value]);
    }
    else {
      setSelected(prev => prev.filter(item => item !== value));
    }
  }

  function handleCommentsChange(e) {
    setCommentsError(""); // Clear error when user types
    setComments(e.target.value);
  }

  function handleClose(){
    props.onClose()
    setSelected([]);
    setComments("");
    setCheckboxError("");
    setCommentsError("");
  }

  return <>
    <SlDialog
      className="cds-scrim-dark dislike-modal"
      label="Let us know why you didn't like the article?"
      open={props.open}
      onSlAfterHide={handleClose}
    >

      <p className="subtitle">
        Please select the most appropriate options
      </p>
      {checkboxError && (
        <p style={{ color: 'red', fontSize: '13px', margin: '0 0 8px 0' }}>{checkboxError}</p>
      )}
      <div className="dislike-options">
        {options.map((opt, index) => (
          <SlCheckbox
            key={index}
            value={opt}
            checked={selected.includes(opt)}
            onSlChange={(e) => handleCheckboxChange(opt, e.target.checked)}
          >
            {opt}
          </SlCheckbox>
        ))}
      </div>

      <div className="textarea-section">
        <label>Any addidtional information you would like us to know?</label>
        {commentsError && (
          <p style={{ color: 'red', fontSize: '13px', margin: '0 0 8px 0' }}>{commentsError}</p>
        )}
        <textarea rows="4" value={comments} onChange={handleCommentsChange}></textarea>
      </div>
      <div
        className="cds-dialog-footer-layout"
        slot="footer"
      >
        <React.Fragment key=".0">
          <SlButton
            className=""
            size="medium"
            variant="primary"
            onClick={handleSubmit}
            loading={isSubmitting}
            disabled={isSubmitting}
          >
            Submit
          </SlButton>
        </React.Fragment>
      </div>
    </SlDialog>
  </>
}